<template>
  <div
    v-if="isLoading"
    v-loading="isLoading"
    class="loading"
    element-loading-text="Cargando pedidos..."
  >
    <el-loading :lock="true"></el-loading>
  </div>
  <div
    v-else
    id="pedido-table"
    ref="tableContainer"
    v-loading="isLoading"
    class="pedido-table"
  >
    <div
      id="table-scroll"
      class="table-scroll"
    >
      <OrderImportItem
        v-for="pedido in pedidos"
        :key="pedido.Codigo"
        :item="pedido"
      />
      <InfiniteLoading
        ref="infiniteLoading"
        :key="identifier"
        :distance="200"
        :target="'#table-scroll'"
        :firstload="firstLoad"
        @infinite="infiniteHandler"
      >
        <template #spinner>Cargando datos...</template>
        <template #complete>No hay mas datos...</template>
        <template #error>Hubo un error...</template>
      </InfiniteLoading>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import 'v3-infinite-loading/lib/style.css';
import { ElLoading } from 'element-plus';
import OrderImportItem from './order_import_item.vue';
import InfiniteLoading from 'v3-infinite-loading';
import { useOrderImportStore } from '@/views/order_import/stores/order_import_store';

const orderImportStore = useOrderImportStore();

const infiniteLoading = ref(null);
const tableContainer = ref(null);
const identifier = ref(Date.now());
const firstLoad = ref(false);
const isLoading = ref(false);

const props = defineProps({
  pedidos: { type: Array, default: () => [] },
});

const infiniteHandler = async ($state) => {
  try {
    const result = await orderImportStore.findAllOrderImportHTTP();
    if (result) {
      $state.loaded();
    } else {
      $state.complete();
    }
  } catch (err) {
    $state.error();
    console.error(err);
  }
};

onBeforeMount(async () => {
  isLoading.value = true;
  orderImportStore.setPage(1);
  orderImportStore.emptyList(1);
  await orderImportStore.findAllOrderImportHTTP();
  isLoading.value = false;
});
</script>

<style scoped>
.pedido-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-scroll {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
</style>
